import { render, staticRenderFns } from "./Create-Certificazione.vue?vue&type=template&id=4500f782&scoped=true&"
import script from "./Create-Certificazione.vue?vue&type=script&lang=js&"
export * from "./Create-Certificazione.vue?vue&type=script&lang=js&"
import style0 from "./Create-Certificazione.vue?vue&type=style&index=0&id=4500f782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500f782",
  null
  
)

export default component.exports